<template>
  <div class="axj-within-school">
    <within-school-header
      @create="handleCreate"
    />
    <within-school-main
      :data="tableData"
      @update="handleUpdate"
    />
    <within-school-footer
      :page-data="page"
      @page-change="handlePaginationChange"
    />
    <within-school-edit
      @close="handleClubClose"
      :show.sync="withInEdit.show"
      :is-create="withInEdit.create"
      :withInId="withInEdit.withInId"
      @updated="handleUpdated"
      @created="handleCreated"
    />
  </div>
</template>

<script>
import WithinSchoolHeader from "./component/within-school-header/index";
import WithinSchoolMain from "./component/within-school-main/index";
import WithinSchoolFooter from "./component/within-school-footer/index";
import commonModels from '@/common/models/common-models'
import WithinSchoolEdit from "./action/within-school-edit";
export default {
  name: "axj-within-school",
  components: {WithinSchoolEdit, WithinSchoolFooter, WithinSchoolMain, WithinSchoolHeader},
  created() {
    this.initData()
    let that=this
    window.handleNext=function (){
      if(that.page.page*that.page.limit<that.page.pageTotal){
        that.page.page=that.page.page+1
        that.handlePaginationChange(that.page)
      }
    }
    window.handlePre=function (){
      if(that.page.page>1){
        that.page.page=that.page.page-1
        that.handlePaginationChange(that.page)
      }
    }
  },
  data(){
    return {
      tableData:[],
      page: {
        page: 1,
        limit: 5,
        desc: true,
        preload: true,
        pageTotal: 0
      },
      withInEdit:{
        create:true,
        show:false,
        withInId:undefined
      }
    }
  },
  methods:{
    handlePaginationChange (val) {
      this.page = val
      this.initData()
    },
    handleClubClose(){
      this.withInEdit.show=false
    },
    handleCreate(){
      this.withInEdit.create=true
      this.withInEdit.show=true
    },
    initData(){
      let user=this.$store.getters.getUser
      this.$api.axjInformationApi.withinSchool.listWithinSchool({
        ...this.page,
        // where:JSON.stringify({
        //   user_id:user.infoUserUid
        // }),
        preload:true
      }).then(res=>{
        this.tableData=res.data.lists
        this.page.pageTotal=res.data.total
        commonModels.logs('info','withinSchool','show-club-list-success!',0)
      },error=>{

      })
    },
    handleUpdate(id){
      this.withInEdit.withInId=id
      this.withInEdit.create=false
      this.withInEdit.show=true
    },
    handleUpdated(){
      this.withInEdit.show=false
      this.initData()
    },
    handleCreated(){
      this.withInEdit.show=false
      this.initData()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/axj-information/axj-within-school/index.vue